// extracted by mini-css-extract-plugin
export var auto = "_4c-1";
export var spinner = "_4c-0";